<div class="ipadBorder">
  <div *ngIf="mode === 'static'" class="ipadBackground">
    <div class="previewBackground"></div>
    <picture>
      <source type="image/webp" srcset="/assets/images/ipad-screen.webp">
      <img class="screenshot" src="/assets/images/ipad-screen.png" width="1210" height="910"
           alt="The Dash room display showing the Boardroom in use, with the day's schedule alongside it"
           fetchpriority="high" decoding="async">
    </picture>
    <!-- Buttons before the schedule window on purpose: the footer overlaps
         upward into it, and that overlap has to sit behind the schedule so the
         join between them cannot show. -->
    <div class="sidePanelFooter busy"></div>
    <div class="sidePanelFooter free"></div>
    <!-- The busy overlays are never faded out: they permanently mask what is
         baked into the screenshot, so nothing can ghost through while the free
         ones crossfade in on top. -->
    <div class="sidePanel">
      <div class="sidePanelContent busy"></div>
      <div class="sidePanelContent free"></div>
    </div>
    <div class="livePreviewButton">
      <a class="demoButton" href="https://app.get-dash.com/?demo" (click)="activatePreview($event)">Live demo&nbsp;&nbsp;<span class="icon">a</span></a>
    </div>
  </div>
  <div *ngIf="mode === 'preview'" #preview class="preview">
    <iframe #previewFrame src="/assets/app/app.html?demo" class="iframe" [style.transform]="'scale('+getScaleFactor()+', ' + getScaleFactor() + ')'" [width]="(getIframeWidth())" [height]="(getIframeHeight())"></iframe>
  </div>
  <div class="ipadFrame"></div>
</div>
